<template>
  <div id="centro-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE Especificacion -->
              <v-card flat v-if="tabSelected == 'Configuración de la jornada'">
                <especificacion
                  :show="true"
                  :contratoId="contratoId"
                ></especificacion>
              </v-card>
              <!-- TAB DE VALIDADORES -->
              <v-card flat v-if="tabSelected == 'Validadores'">
                <validadores />
              </v-card>
              <!-- TAB Asistencia -->
              <v-card flat v-if="tabSelected == 'Asistencia'">
                <asistencia />
              </v-card>
              <!-- TAB REPORTE -->
              <v-card flat v-if="tabSelected == 'Reporte'">
                <reporte />
              </v-card>
              <!-- TAB DE REPORTE-DETALLE -->
              <v-card flat v-if="tabSelected == 'Reporte Detalles'">
                <reporte-detalle
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></reporte-detalle>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Especificacion from "@/modules/validaciones/views/especificacion/EspecificacionValidaciones.vue";
import Validadores from "@/modules/validaciones/views/validadores/Validadores.vue";
import Asistencia from "@/modules/validaciones/views/asistencia/AsistenciaValidaciones.vue";
import Reporte from "@/modules/validaciones/views/reporte/ReporteValidaciones.vue";
import ReporteDetalle from "@/modules/validaciones/views/reporteDetalle/ReporteDetalleValidaciones.vue";

export default {
  components: {
    Especificacion,
    Validadores,
    Asistencia,
    Reporte,
    ReporteDetalle,
  },
  props: {
    //tabSelected: String
  },
  data: () => ({
    tabs: [
      "Configuración de la jornada",
      "Validadores",
      "Asistencia",
      "Reporte",
      "Reporte Detalles",
    ],
    contratoId: "",
    tabSelected: "",
    index: "",
    active_tab: "",
  }),
  mounted() {},
  created() {
    this.tab = this.$store.getters.subTabSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.tabSelected = "Configuración de la jornada";
    this.active_tab = this.tabs.indexOf(this.tabSelected);
  },
  methods: {
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
    },
  },
};
</script>
